import { browserType } from ".";

export const FoundersMembers = [
  {
    name: "Hemanth Aluru",
    designation: "CEO & CO-FOUNDER",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/founders1.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/founders1.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
  {
    name: "Sudhindra Reddy",
    designation: "COO & CO-FOUNDER",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/founders2.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/founders2.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
];

export const CommerceMembers = [
  {
    name: "Abishek Gour",
    designation: "HEAD, DATA PRODUCTS",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/o2ocomm_1.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/o2ocomm_1.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
  {
    name: "Kranthi C",
    designation: "HEAD SALES",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/o2ocom_2.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/o2ocom_2.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
  {
    name: "",
    designation: "",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/o2ocomm_3.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/o2ocomm_3.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
  {
    name: "",
    designation: "",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/o2ocomm_4.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/o2ocomm_4.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
];

export const IOTMembers = [
  {
    name: "Hitendra Arvapalli",
    designation: "CO-LEAD, ENGINEERING",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/iot_battery1.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/iot_battery1.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
  {
    name: "Karthink Ganesh",
    designation: "HEAD OF BATTERY TECH",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/iot_battery2.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/iot_battery2.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
];

export const CreditMembers = [
  {
    name: "Devnyash Goel",
    designation: "CFO",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/credit1.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/credit1.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
  {
    name: "Varun Nair",
    designation: "HEAD OF PRODUCT",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/credit2.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/credit2.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
];

export const BatteryMembers = [
  {
    name: "Achal Bassamboo",
    designation: "",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/battery1.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/battery1.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
  {
    name: "Milind Sohoni",
    designation: "",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/battery2.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/battery2.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
  {
    name: "Neha Sharma",
    designation: "",
    description:
      "Professor Bassamboo joined the faculty at the Kellogg School of Management in 2005, after completing his Ph.D. in Operations, Information and Technology at the Stanford Graduate School of Business. His research interests lie in the areas of service systems, revenue management and information sharing. His current research involves designing flexible service systems and effects of parameter uncertainty.",
    profile_img:
      browserType === "Chrome"
        ? `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/avif+/battery3.avif`
        : `${process.env.NEXT_PUBLIC_CDN_LINK}AboutUs/fold+5/battery3.jpg`,
    twitter_link: "",
    linked_in_link: "",
  },
];
